import { LocalDate } from '../../../utilities/local-date';
import { findHolidayName } from '../calendar/find-holiday-name';
import type { WorkScheduleDay } from '@trinnvis/dabih-api-client';
import { getScheduleForDay } from './get-schedule-for-day';
import { timeInMinutes } from './time-in-minutes';

import { employeeCurrentSchedule } from './employee-current-schedule';
import type { WorkDay } from '../../../pages/staffing-page/work-day';

export function calculateScheduledWorkDay(workSchedules, day): WorkDay {
  const date = LocalDate.fromString(day);
  const currentSchedule = employeeCurrentSchedule(workSchedules, date);
  if (currentSchedule.holidaysAreTimeOff && findHolidayName(day) !== '') {
    return { workDay: false };
  }
  const weeksInSchedule = currentSchedule.workWeeks.length;
  const scheduleDay: WorkScheduleDay = getScheduleForDay(weeksInSchedule, currentSchedule, date);
  if (scheduleDay.workDay) {
    const start = scheduleDay.start || '00:00';
    const end = scheduleDay.end || '00:00';
    let workMinutes = timeInMinutes(end) - timeInMinutes(start);
    if (currentSchedule.restPeriod === 'WITHOUT_PAY') {
      workMinutes -= 30;
    }
    return {
      workDay: true,
      start,
      end,
      workMinutes,
    };
  } else {
    return {
      workDay: false,
      workMinutes: 0,
    };
  }
}
